import { useQuery } from "@tanstack/react-query";
import { cornerstoneAutoFinalizeKey, fetchCornerstoneAutoFinalize } from "@common/lib/api/cornerstoneSettings";
import { useAccountContext } from "@/state/providers/AccountProvider";

/** EN-1320: the clinic's auto-finalize setting. The key carries the account id so a clinic switch never shows stale days. */
export function useCornerstoneAutoFinalize(enabled: boolean) {
    const { accountData } = useAccountContext();
    const accountId = accountData?.id;
    return useQuery({
        queryKey: cornerstoneAutoFinalizeKey(accountId),
        // `enabled` requires accountId, so the query never runs without one.
        queryFn: () => fetchCornerstoneAutoFinalize(accountId as string),
        enabled: enabled && !!accountId,
    });
}
